import { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import { TextField, MenuItem, Typography, Button, Box } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useFormik } from "formik";
import * as yup from "yup";
import UserService from "../../services/user";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const validationSchema = yup.object({
  mentor_id: yup.string("Enter Mentor name").required("Mentor is required"),
  subject: yup.string("Subject").required("Subject is required"),
  description: yup.string().required("Description is required"),
  email: yup.string("Enter email").email().required("Email is required"),
});

export default function SendEmailModal({ open, onClose, onSubmit }) {
  const [rowMentor, setRowMentor] = useState([]);

  const formik = useFormik({
    initialValues: {
      email: "",
      mentor_id: "",
      subject: "",
      desctipton: "",
      file: null,

    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append("email", values.email);
      formData.append("mentor_id", values.mentor_id);
      formData.append("subject", values.subject);
      formData.append("description", values.description);
      if (values.file) {
        formData.append("file", values.file);
      }

      onSubmit(formData); // pass FormData to your parent component
    },
  });

  const getMentors = async () => {
    try {
      let { data } = await UserService.fetchMentor();
      setRowMentor(data.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getMentors();
  }, []);

  useEffect(() => {
    if (formik.values.mentor_id) {
      const mentorEmail = rowMentor.find(
        (m) => m.id === formik.values.mentor_id
      )?.email;
      formik.setFieldValue("email", mentorEmail);
    }
  }, [formik.values.mentor_id]);

  return (
    <div>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="modal-sm">
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Send Email
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <form onSubmit={formik.handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    select
                    fullWidth
                    id="mentor_id"
                    name="mentor_id"
                    label="Select Mentor"
                    value={formik.values.mentor_id}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    margin="dense"
                    size="small"
                    error={
                      formik.touched.mentor_id &&
                      Boolean(formik.errors.mentor_id)
                    }
                    helperText={
                      formik.touched.mentor_id && formik.errors.mentor_id
                    }
                  >
                    <MenuItem value={""}>Select Mentor</MenuItem>
                    {rowMentor?.map((mentor) => (
                      <MenuItem value={mentor.id}>{mentor.full_name}</MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    id="email"
                    name="email"
                    label="Email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    multiline
                    margin="dense"
                    size="small"
                    error={formik.touched.email && Boolean(formik.errors.email)}
                    helperText={formik.touched.email && formik.errors.email}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    id="subject"
                    name="subject"
                    label="Subject"
                    value={formik.values.subject}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    multiline
                    margin="dense"
                    size="small"
                    error={
                      formik.touched.subject && Boolean(formik.errors.subject)
                    }
                    helperText={formik.touched.subject && formik.errors.subject}
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    id="description"
                    name="description"
                    label="Description"
                    value={formik.values.description}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    multiline
                    margin="dense"
                    size="small"
                    rows={4}
                    error={
                      formik.touched.description &&
                      Boolean(formik.errors.description)
                    }
                    helperText={
                      formik.touched.description && formik.errors.description
                    }
                  />
                </Grid>

                <Grid item xs={12}>
                  <Button
                    variant="outlined"
                    component="label"
                    fullWidth
                    sx={{ textTransform: "none" }}
                  >
                    Upload File
                    <input
                      type="file"
                      hidden
                      onChange={(event) => {
                        formik.setFieldValue(
                          "file",
                          event.currentTarget.files[0]
                        );
                      }}
                    />
                  </Button>
                  {formik.values.file && (
                    <Typography variant="body2" sx={{ mt: 1 }}>
                      Selected File: {formik.values.file.name}
                    </Typography>
                  )}
                </Grid>
              </Grid>
              <div className="text-right">
                <Button
                  color="primary"
                  sx={{ mr: 1, mt: 1 }}
                  variant="contained"
                  type="submit"
                >
                  Send
                </Button>
                <Button onClick={onClose} sx={{ mt: 1 }} variant="outlined">
                  Cancel
                </Button>
              </div>
            </form>
          </Typography>
        </Box>
      </Modal>
    </div>
  );
}
